export default __webpack_public_path__ + "50f0357754e90d9965e838f552882ad4.svg";